import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Centered loading spinner matching the demo app style.
 * @param {string} message - Primary loading message
 * @param {string} subMessage - Secondary message below the primary
 */
export default function LoadingSpinner({
  message = "Loading...",
  subMessage = "Please wait while we fetch your data",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        py: 10,
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <svg
          style={{
            width: 48,
            height: 48,
            color: "#6366f1",
            margin: "0 auto 16px",
            display: "block",
            animation: "spin 1s linear infinite",
          }}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            style={{ opacity: 0.25 }}
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            style={{ opacity: 0.75 }}
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <Typography sx={{ fontSize: "1rem", fontWeight: 500, color: "#334155" }}>
          {message}
        </Typography>
        {subMessage && (
          <Typography sx={{ fontSize: "0.875rem", color: "#64748b", mt: "6px" }}>
            {subMessage}
          </Typography>
        )}
      </Box>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
}
